import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ENGLISH, JAPANESE, SPANISH } from 'constants/language';
import { MOTIVATOR_COLORS, ID_SORTED_SCALES } from 'constants/scales';
import LoginRedirectButton from 'components/LoginRedirectButton';
import i18n from 'i18next';
import PersonalizedTip from './PersonalizedTip';
import PreparingTip from './PreparingTip';
import NoTip from './NoTip';
import './styles.scss';
import { trackMixpanelEvent } from '../../../../utils';
import { MIX_PANEL_EVENTS } from '../../../../constants/mixpanel';

const { ENGAGEMENT_SURVEY } = MIX_PANEL_EVENTS;

let didInit = false;

const CoachingTip = ({ tip }) => {
    if (!tip) return <NoTip />;

    const [isAnimate, setIsAnimate] = useState(false);
    const [isShowToolTip, setIsShowToolTip] = useState(false);

    const textColor = MOTIVATOR_COLORS[`${ ID_SORTED_SCALES[tip.scale_id - 1] }`];
    const tipText = {
        [JAPANESE]: tip.text_ja,
        [SPANISH]: tip.text_es,
        [ENGLISH]: tip.text_en
    }[i18n.language] || tip.text_en;

    if (!didInit) {
        setTimeout(() => setIsAnimate(true), 1000);
        setTimeout(() => setIsShowToolTip(true), 1000);
        didInit = true;
    }

    useEffect(() => {
        trackMixpanelEvent({
            eventName: ENGAGEMENT_SURVEY.ENGAGEMENT_SURVEY_SHOW_COMMUNICATION_TIP,
            properties: {
                scaleId: tip.scale_id,
                category: tip.category
            }
        });
    }, []);

    return (
        <div className='coaching-tip-container'>
            <PersonalizedTip
                tipScale={ tip.scale_id }
                tipText={ tipText }
                textColor={ textColor }
                isShowToolTip={ isShowToolTip } />
            <PreparingTip
                tipText={ tipText }
                textColor={ textColor }
                isAnimate={ isAnimate }
                isShowToolTip={ isShowToolTip } />
            {
                isShowToolTip && (
                    <LoginRedirectButton />
                )
            }
        </div>
    );
};

CoachingTip.propTypes = {
    tip: PropTypes.object
};

export default CoachingTip;
